import * as Sentry from '@sentry/react';

export interface ApiTelemetryAttributes {
  endpoint: string;
  method: string;
  status: number;
  ok: boolean;
}

interface SentryTelemetryClient {
  metrics?: {
    distribution?: (
      name: string,
      value: number,
      options?: { unit?: string; attributes?: ApiTelemetryAttributes },
    ) => void;
    count?: (
      name: string,
      value?: number,
      options?: { unit?: string; attributes?: ApiTelemetryAttributes },
    ) => void;
  };
  logger?: {
    error?: (
      message: string,
      attributes?: ApiTelemetryAttributes & { error?: string },
    ) => void;
  };
}

let telemetryClient: SentryTelemetryClient = Sentry as unknown as SentryTelemetryClient;

export function __setSentryTelemetryClientForTest(client: SentryTelemetryClient | null): void {
  telemetryClient = client ?? (Sentry as unknown as SentryTelemetryClient);
}

export function recordApiDuration(
  metricName: string,
  ms: number,
  attributes: ApiTelemetryAttributes,
): void {
  try {
    telemetryClient.metrics?.distribution?.(metricName, ms, {
      unit: 'millisecond',
      attributes,
    });
  } catch {
    // Never break application behavior due to telemetry errors.
  }
}

export function recordApiError(
  endpoint: string,
  status: number,
  message: string,
  method = 'POST',
): void {
  const attributes: ApiTelemetryAttributes = {
    endpoint,
    method,
    status,
    ok: false,
  };

  try {
    telemetryClient.metrics?.count?.('api.error.count', 1, { attributes });
  } catch {
    // Never break application behavior due to telemetry errors.
  }

  try {
    telemetryClient.logger?.error?.('API request failed', {
      ...attributes,
      error: message,
    });
  } catch {
    // Never break application behavior due to telemetry errors.
  }
}
